import { Volume } from './src/Volume'
export { Volume }
export default Volume



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/components/Volume/index.ts